// External
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { catchError, concat, last, map, Observable, of } from 'rxjs';
import { AuthGuard } from './auth.guard';
import { MessageService } from '../services/_app/message/message.service';
import { EVENTS } from '../services/_constants/values/values.service';
import { NavigationGuard } from './navigation.guard';


@Injectable({
    providedIn: 'root'
})

export class CombinedMainGuard {

    private _activated = false;

    constructor(
        private readonly authGuard: AuthGuard,
        private readonly navigationGuard: NavigationGuard,
        private readonly messageService: MessageService,
    ) {
        this.messageService.getMessage()
        .subscribe((message: any) => {
            if (message.text === EVENTS.languageChanged) {
                this._activated = false;
            }
        });
    }

    activateGuard() {
        this._activated = false;
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
        const computeResp = (resp: any) => {
            // Daca returneaza URLTree sau false iese din concat
            // Daca returneaza true continua concat-ul
            if (resp !== true) {
                throw resp;
            } else {
                return resp;
            }
        }

        return concat(
            this.authGuard.canActivate(route, state).pipe(map(computeResp)),
            this.navigationGuard.canActivate(route, state).pipe(map(computeResp))
        ).pipe(
            last(),
            map(
                (res) => {
                    this._activated = true;
                    return res;
                }
            ),
            catchError(
                (err) => {
                    return of(err);
                }
            )
        );
    }

}
